// extracted by mini-css-extract-plugin
module.exports = {"container":"clientNavBar_container__vBbMc","link":"clientNavBar_link__1KeDJ","more":"clientNavBar_more__2kqpk","notification":"clientNavBar_notification__2e6kA"};